var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeedback(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 75 75",
    xmlSpace: "preserve",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    stroke: "currentColor",
    strokeMiterlimit: 10,
    strokeWidth: 3.5,
    className: "stroke-394553"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.594 47.516c1.91-.57 9.051-3.232 9.051-11.505 0 0 .164-2.099 2.482-2.099 0 0 2.547-.26 2.822 2.625 0 0 .654 5.542-1.162 9.172h8.514c.35 0 1.684-.061 2.422 1.197.504.859.352 2.014.209 2.854-.139.838-2.703 13.826-2.703 13.826-.281 1.193-1.318 2.543-3.256 2.543H48.371"
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinecap: "round",
    d: "M37.043 46.918h7.336v20.664h-7.336v-9.787z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.871 40.984V20.02a3.115 3.115 0 0 0-3.105-3.107h-51.73a3.114 3.114 0 0 0-3.106 3.107v34.255a3.114 3.114 0 0 0 3.106 3.105h3.938v10.707l8.052-10.707h4.947",
    strokeLinejoin: "round"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeedback);
export default __webpack_public_path__ + "static/media/Feedback.2afbe8f074288710cc23132b7138be18.svg";
export { ForwardRef as ReactComponent };